/**
 * Success Stories variant 2 — Student Showcase (ASU-009).
 *
 * Figma (Atlas Website, file PdDGTiH65FKjDxz4cIVllK):
 *   1750 12178:1029 · 1430 12169:528 · 1230 12170:782 · 1080 12174:903 · mobile 12208:18937
 *
 * Heading + subtitle + a carousel of image cards. Each card is a single
 * uploaded image (name / role / logo / photo baked into the image — nothing is
 * coded inside the card). Desktop shows a paged 4-column grid (up to 8 cards per
 * page, arrows + dots when >8); mobile is a single-row peek carousel with no
 * navigation. Reuses the success_stories columns; the only new columns are
 * subtitle + subtitle_text_color.
 */
const IMAGE_ACCEPT = "image/png,image/jpeg,image/webp,image/gif,image/svg+xml";

export const SUCCESS_STORIES_2_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Cards (each card is one uploaded image; min 2, max 100)",
  },

  METADATA_LIMITS: {
    metadata: { min: 2, max: 100 },
  },

  // Card row — a single uploaded image.
  DEFAULT_ROW: {
    id: "1",
    image: "",
    alt_image: "",
    priority: 1,
    status: true,
  },

  SUCCESS_STORIES_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "ATLAS Student Join Industry Leaders",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter heading",
      required: false,
      defaultValue: "ATLAS Student Join Industry Leaders",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#DDE567",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #DDE567",
      required: false,
      defaultValue: "#DDE567",
    },
    {
      fieldName: "subtitle",
      label: "Subtitle",
      value:
        "Career growth, industry opportunities, and professional success stories from the ATLAS ecosystem",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter subtitle",
      required: false,
      defaultValue:
        "Career growth, industry opportunities, and professional success stories from the ATLAS ecosystem",
    },
    {
      fieldName: "subtitle_text_color",
      label: "Subtitle colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_color",
      label: "Background colour",
      value: "#081F3D",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #081F3D",
      required: false,
      defaultValue: "#081F3D",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left arrow icon (optional — defaults to a lime arrow)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload left arrow icon",
      required: false,
      defaultValue: "",
      accept: IMAGE_ACCEPT,
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Left arrow alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text for left arrow",
      required: false,
      defaultValue: "Previous",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right arrow icon (optional — defaults to a lime arrow)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload right arrow icon",
      required: false,
      defaultValue: "",
      accept: IMAGE_ACCEPT,
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Right arrow alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text for right arrow",
      required: false,
      defaultValue: "Next",
    },
    {
      fieldName: "indicator_color",
      label: "Carousel indicator colour (dots + default arrows)",
      value: "#DDE567",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #DDE567",
      required: false,
      defaultValue: "#DDE567",
    },
    {
      fieldName: "status",
      label: "Student Showcase Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],

  // metadata — image cards (min 1)
  METADATA_FIELDS: [
    {
      header: "Card image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload card image",
      required: true,
      accept: IMAGE_ACCEPT,
    },
    {
      header: "Image alt text",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Display order (lower first)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable this card",
      defaultValue: true,
    },
  ],
};
